import * as React from 'react';
import { Modal } from "../../../modal/Modal";
import { useMemo, useRef } from "react";
import { IntlProvider, useIntl } from 'react-intl';
import { YourFirstReport } from './pages/YourFirstReport';
import { SummaryComment } from './pages/SummaryComment';
import { DiscrepancyManagement } from './pages/DiscrepancyManagement';
import { AccessToReport } from './pages/AccessToReport';
import { EndPage } from './pages/EndPage';
export const ReadReportGuideModal = props => {
    const { onClose } = props;
    const intl = useIntl();
    const containerRef = useRef(null);
    const [pageIndex, setPageIndex] = React.useState(0);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [buttonClicked, setButtonClicked] = React.useState("");
    const pages = [
        React.createElement(YourFirstReport, null),
        React.createElement(SummaryComment, null),
        React.createElement(DiscrepancyManagement, null),
        React.createElement(AccessToReport, null),
        React.createElement(EndPage, null),
    ];
    React.useEffect(() => {
        if (!containerRef.current)
            return;
        const handleTabDown = () => setSelectedIndex((prev) => prev + 1);
        const handleShiftTabDown = () => setSelectedIndex((prev) => prev - 1);
        const handleKeyDown = (e) => {
            switch (e.key) {
                case 'Tab':
                    e.preventDefault();
                    return e.shiftKey ? handleShiftTabDown() : handleTabDown();
                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    return nextPage();
                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    return prevPage();
            }
        };
        const previousBodyOverflowStyle = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        containerRef.current.addEventListener("keydown", handleKeyDown);
        return () => {
            document.body.style.overflow = previousBodyOverflowStyle;
            containerRef.current.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    React.useEffect(() => {
        const focusableElements = containerRef.current.querySelectorAll("button, a[href]");
        if (selectedIndex < 0) {
            setSelectedIndex(focusableElements.length - 1);
            return;
        }
        focusableElements[selectedIndex % focusableElements.length].focus();
    }, [selectedIndex, pageIndex, buttonClicked]);
    React.useEffect(() => {
        const focusableElements = containerRef.current.querySelectorAll("button, a[href]");
        if (buttonClicked === "next") {
            setSelectedIndex(focusableElements.length - 1);
        }
        if (buttonClicked === "prev") {
            setSelectedIndex(focusableElements.length - 2);
        }
        if (pageIndex > pages.length - 1)
            onClose();
    }, [pageIndex, buttonClicked]);
    const nextPageButtonText = useMemo(() => {
        return (pages.length > (pageIndex + 1))
            ? intl.formatMessage({ id: 'readreport.guidemodal.buttons.next' })
            : intl.formatMessage({ id: 'readreport.guidemodal.buttons.done' });
    }, [pageIndex]);
    const nextPage = () => {
        setPageIndex((prev) => prev + 1);
        setButtonClicked("next");
    };
    const prevPage = () => {
        setPageIndex((prev) => prev > 0 ? prev - 1 : 0);
        setButtonClicked("prev");
    };
    const previousButtonText = intl.formatMessage({ id: 'readreport.guidemodal.buttons.previous' });
    return (React.createElement(Modal, { onCloseClick: onClose, xl: true },
        React.createElement("article", { ref: containerRef, className: "ReadReportGuideModal", tabIndex: -1, "aria-atomic": true, "aria-live": "polite" },
            React.createElement(IntlProvider, { locale: intl.locale, messages: intl.messages, textComponent: React.Fragment }, pages[pageIndex]),
            React.createElement("div", { className: "PrevNextButtonsLayout" },
                pageIndex > 0
                    ? React.createElement("button", { onClick: prevPage, className: "PrevButton", type: 'button', "aria-label": previousButtonText }, previousButtonText)
                    : React.createElement("span", null),
                React.createElement("button", { onClick: nextPage, className: "NextButton", type: 'button', "aria-label": `${nextPageButtonText}` }, nextPageButtonText)))));
};
export const FormattedMessage = ({ id }) => {
    const intl = useIntl();
    const intlMessage = intl.formatMessage({ id }, {
        tofindout: (content) => React.createElement("span", { "aria-label": 'To Find Out', lang: 'en' }, content),
        b: (content) => React.createElement("b", null, content),
        i: (content) => React.createElement("i", null, content),
        centereditalic: (content) => React.createElement("span", { className: 'centeredItalic' }, content),
        ul: (content) => React.createElement("ul", null, content),
        li: (content) => React.createElement("li", { className: 'listItem' }, content),
        mailus: (content) => React.createElement("a", { href: "mailto:kund@tofindout.se", target: "_blank" }, content)
    });
    return React.createElement(React.Fragment, null, intlMessage);
};
